import { createAsyncThunk } from "@reduxjs/toolkit";
import localForage from "localforage";

import { getColorMode } from "Libs/themes";
import { selectCurrentUserUsername } from "Reducers/app/selectors";
import { profileColorScheme } from "Reducers/profile";

import { loadTheme } from "./loadTheme.thunk";

import type { AsyncThunkOptionType } from "Reducers/types";

export const setThemeFromProfile = createAsyncThunk<
  undefined,
  { profile?: { ui_colorscheme: string } },
  AsyncThunkOptionType
>(
  "app/theme/theme_by_profile",
  async ({ profile }, { rejectWithValue, getState, dispatch }) => {
    try {
      const username = selectCurrentUserUsername(getState());

      const colorSchemeFromCache: string = await getColorMode();
      const colorSchemeFromProfile =
        profile?.ui_colorscheme || profileColorScheme(getState(), username);

      if (colorSchemeFromCache !== colorSchemeFromProfile) {
        await localForage.setItem("ui_colorscheme", colorSchemeFromProfile);
      }

      dispatch(loadTheme());
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
